export default "__VITE_ASSET__DCSzgCG1__"